export function dateDiffFormatter(value) {
  // 时间戳转成date
  const date = new Date(value * 1000)
  // 计算date与当前时间的时间差并格式化返回
  const diff = parseInt((new Date() - date) / 1000)
  if (diff < 60) {
    return diff + '秒前'
  } else if (diff < 3600) {
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 86400) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 2592000) {
    return Math.ceil(diff / 86400) + '天前'
  } else if (diff < 31104000) {
    return Math.ceil(diff / 2592000) + '月前'
  } else {
    return Math.ceil(diff / 31104000) + '年前'
  }
}

